import * as Yup from 'yup';
import { transactionsTypesTranslations } from 'constants/transactionTypes';

export const getTransactionSchema = (paymentMethods, isMethodOptional = false) => {
  const baseShape = {
    type: Yup.string().oneOf(Object.keys(transactionsTypesTranslations)).required('Тип обовʼязковий'),
    description: Yup.string().required('Опис обовʼязковий'),
    amount: Yup.number()
      .typeError('Сума повинна бути числом')
      .positive('Сума повинна бути додатньою')
      .required('Сума обовʼязкова'),
  };

  if (!isMethodOptional) {
    baseShape.methodID = Yup.number()
      .oneOf(paymentMethods.map((m) => m.id))
      .required('Метод оплати обовʼязковий');
  }

  return Yup.object().shape(baseShape);
};
